import { AnyAction, configureStore, createListenerMiddleware, isRejected } from '@reduxjs/toolkit';
import * as Sentry from '@sentry/react';
import { enqueueSnackbar } from 'notistack';

import { resettableRootReducer } from './RootReducer';

const listenerMiddleware = createListenerMiddleware();
listenerMiddleware.startListening({
  effect: (action: AnyAction) => {
    const {
      payload: { data, statusText },
    } = action;

    const message = (statusText || data?.detail) as string;

    enqueueSnackbar(message);
  },
  matcher: isRejected,
});

export const store = configureStore({
  devTools: import.meta.env.DEV,
  reducer: resettableRootReducer,
  // eslint-disable-next-line perfectionist/sort-objects
  middleware: (getDefaultMiddleware) => getDefaultMiddleware().prepend(listenerMiddleware.middleware),
  // eslint-disable-next-line perfectionist/sort-objects
  enhancers: (getDefaultEnhancers) => getDefaultEnhancers().concat(Sentry.createReduxEnhancer({})),
});
export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
